import React from 'react';
import PropTypes from 'prop-types';

export function Page({ className, ...props }) {
  return <div className={`flex flex-col items-center justify-start w-full ${className}`} {...props} />;
}

Page.propTypes = {
  className: PropTypes.string,
};

Page.defaultProps = {
  className: null,
};
